import { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Axios } from "../../../Api/axios";
import {
  ADMIN_ONE_INTENSIVE,
  ADMIN_UPDATE_INTENSIVE,
  ADMIN_ALL_CLASSES,
  ADMIN_ALL_SUBJECTS,
  baseURL,
} from "../../../Api/Api";
import LoadingSubmit from "../../../Components/Loading/Loading";
import DashDialog from "../../../Components/Dashboard/DashDialog";
import { Form, FormControl, FormGroup } from "react-bootstrap";
import "./AddIntensive.css";

const DAYS  = ["السبت", "الأحد", "الاثنين", "الثلاثاء", "الأربعاء", "الخميس", "الجمعة"];
const UNITS = ["يوم", "أسبوع", "شهر"];

export default function Intensive() {
  const { id } = useParams();
  const nav    = useNavigate();

  const [classes,  setClasses]  = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [loading,  setLoading]  = useState(false);
  const [fetching, setFetching] = useState(true);
  const [error,    setError]    = useState("");

  /* form fields */
  const [classId,       setClassId]       = useState("");
  const [subjectMode,   setSubjectMode]   = useState("existing");
  const [subjectId,     setSubjectId]     = useState("");
  const [subjectCustom, setSubjectCustom] = useState("");
  const [teacherName,   setTeacherName]   = useState("");
  const [startDate,     setStartDate]     = useState("");
  const [durationValue, setDurationValue] = useState("");
  const [durationUnit,  setDurationUnit]  = useState("شهر");
  const [schedule,      setSchedule]      = useState({});
  const [photo,         setPhoto]         = useState(null);
  const [currentPhoto,  setCurrentPhoto]  = useState(null);

  /* load classes + subjects + existing course */
  useEffect(() => {
    Axios.get(ADMIN_ALL_CLASSES)
      .then((r) => setClasses(r.data.classes || []))
      .catch(() => {});
    Axios.get(ADMIN_ALL_SUBJECTS)
      .then((r) => setSubjects(r.data.subjects || []))
      .catch(() => {});
  }, []);

  useEffect(() => {
    setFetching(true);
    Axios.get(ADMIN_ONE_INTENSIVE(id))
      .then((r) => {
        const c = r.data.one_intensive || r.data;
        setTeacherName(c.name   || "");
        setClassId(   c.class_id   ? String(c.class_id)   : "");
        setStartDate( c.start_date ? c.start_date.slice(0, 10) : "");
        setDurationValue(c.duration_value ? String(c.duration_value) : "");
        setDurationUnit( c.duration_unit  || "شهر");
        setCurrentPhoto( c.photo || null);

        if (c.subject_id) {
          setSubjectMode("existing");
          setSubjectId(String(c.subject_id));
        } else if (c.subject_custom) {
          setSubjectMode("custom");
          setSubjectCustom(c.subject_custom);
        }

        /* parse schedule */
        if (c.times) {
          try {
            const arr = typeof c.times === "string" ? JSON.parse(c.times) : c.times;
            if (Array.isArray(arr)) {
              const map = {};
              arr.forEach((s) => { map[s.day] = { time: s.time || "09:00", hours: s.hours || "" }; });
              setSchedule(map);
            }
          } catch {}
        }
      })
      .catch(() => setError("تعذر تحميل بيانات الدورة"))
      .finally(() => setFetching(false));
  }, [id]);

  function toggleDay(day) {
    setSchedule((prev) => {
      const next = { ...prev };
      if (day in next) delete next[day];
      else next[day] = { time: "09:00", hours: "" };
      return next;
    });
  }
  function setDayField(day, field, value) {
    setSchedule((prev) => ({ ...prev, [day]: { ...prev[day], [field]: value } }));
  }

  const subjectOk = subjectMode === "existing"
    ? !!subjectId
    : subjectCustom.trim().length >= 2;
  const isValid = teacherName.trim().length >= 2 && subjectOk;

  async function handleSubmit() {
    if (!isValid) return;
    setLoading(true);
    setError("");

    const scheduleArr = DAYS
      .filter((d) => d in schedule)
      .map((d) => ({ day: d, time: schedule[d].time, hours: schedule[d].hours || null }));

    const fd = new FormData();
    fd.append("intensive_id",  id);
    fd.append("name",          teacherName.trim());
    fd.append("class_id",      classId       || "");
    fd.append("duration_unit", durationUnit);
    if (subjectMode === "existing") {
      fd.append("subject_id",     subjectId);
      fd.append("subject_custom", "");
    } else {
      fd.append("subject_id",     "");
      fd.append("subject_custom", subjectCustom.trim());
    }
    if (startDate)     fd.append("start_date",     startDate);
    if (durationValue) fd.append("duration_value", durationValue);
    if (scheduleArr.length > 0) fd.append("times", JSON.stringify(scheduleArr));
    if (photo)         fd.append("photo", photo);

    try {
      await Axios.put(ADMIN_UPDATE_INTENSIVE, fd);
      nav("/dashboard/T_Intensive");
    } catch (err) {
      setError(err?.response?.data?.message || "حدث خطأ أثناء الحفظ");
      setLoading(false);
    }
  }

  if (fetching) return <div className="dash-page" style={{ padding: 40, color: "#9ca3af" }}>جاري التحميل...</div>;

  return (
    <>
      {loading && <LoadingSubmit />}
      <DashDialog
        title="تعديل الدورة المكثفة"
        onSubmit={handleSubmit}
        submitDisabled={!isValid || loading}
        submitLabel={loading ? "جاري الحفظ..." : "حفظ التعديلات"}
        onClose={() => nav("/dashboard/T_Intensive")}
      >
        {error && (
          <div style={{ background: "#fef2f2", border: "1px solid #fecaca", color: "#dc2626", padding: "10px 14px", borderRadius: 10, marginBottom: 16, fontSize: "0.87rem" }}>
            {error}
          </div>
        )}

        {/* Class */}
        <Form.Group className="mb-4" controlId="classId">
          <Form.Label>الصف <span className="ai-optional">(اختياري)</span></Form.Label>
          <Form.Select value={classId} onChange={(e) => setClassId(e.target.value)}>
            <option value="">بدون صف محدد</option>
            {classes.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
          </Form.Select>
        </Form.Group>

        {/* Subject */}
        <Form.Group className="mb-3">
          <Form.Label>المادة</Form.Label>
          <div className="ai-toggle-row">
            <button type="button"
              className={`ai-toggle-btn ${subjectMode === "existing" ? "active" : ""}`}
              onClick={() => setSubjectMode("existing")}>
              <svg width="14" height="14" fill="currentColor" viewBox="0 0 24 24">
                <path d="M12 3L1 9l11 6 9-4.91V17h2V9L12 3z" />
              </svg>
              من مواد المعهد
            </button>
            <button type="button"
              className={`ai-toggle-btn ${subjectMode === "custom" ? "active" : ""}`}
              onClick={() => setSubjectMode("custom")}>
              <svg width="14" height="14" fill="currentColor" viewBox="0 0 24 24">
                <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04a1 1 0 0 0 0-1.41l-2.34-2.34a1 1 0 0 0-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z" />
              </svg>
              مادة أخرى
            </button>
          </div>

          {subjectMode === "existing" ? (
            <Form.Select className="mt-2" value={subjectId} onChange={(e) => setSubjectId(e.target.value)}>
              <option value="">اختر المادة...</option>
              {subjects.map((s) => <option key={s.id} value={s.id}>{s.name}</option>)}
            </Form.Select>
          ) : (
            <Form.Control className="mt-2" type="text" placeholder="اسم المادة..."
              value={subjectCustom} onChange={(e) => setSubjectCustom(e.target.value)} />
          )}
        </Form.Group>

        {/* Teacher */}
        <Form.Group className="mb-4" controlId="teacherName">
          <Form.Label>أستاذ الدورة</Form.Label>
          <Form.Control type="text" placeholder="اسم الأستاذ..."
            value={teacherName} onChange={(e) => setTeacherName(e.target.value)} required />
        </Form.Group>

        {/* Start date */}
        <Form.Group className="mb-4" controlId="startDate">
          <Form.Label>تاريخ البدء <span className="ai-optional">(اختياري)</span></Form.Label>
          <Form.Control type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} />
        </Form.Group>

        {/* Duration */}
        <Form.Group className="mb-4">
          <Form.Label>المدة <span className="ai-optional">(اختياري)</span></Form.Label>
          <div className="ai-duration-row">
            <Form.Control type="number" min="1" placeholder="العدد..."
              value={durationValue} onChange={(e) => setDurationValue(e.target.value)}
              className="ai-duration-num" />
            <div className="ai-unit-group">
              {UNITS.map((u) => (
                <button key={u} type="button"
                  className={`ai-unit-btn ${durationUnit === u ? "active" : ""}`}
                  onClick={() => setDurationUnit(u)}>
                  {u}
                </button>
              ))}
            </div>
          </div>
        </Form.Group>

        {/* Schedule */}
        <Form.Group className="mb-4">
          <Form.Label>أيام وأوقات الدورة <span className="ai-optional">(اختياري)</span></Form.Label>
          <div className="ai-days-grid">
            {DAYS.map((day) => {
              const selected = day in schedule;
              return (
                <div key={day} className={`ai-day-row ${selected ? "ai-day-row--on" : ""}`}>
                  <label className="ai-day-check">
                    <input type="checkbox" checked={selected} onChange={() => toggleDay(day)} />
                    <span className="ai-day-label">{day}</span>
                  </label>
                  {selected && (
                    <>
                      <input type="time" className="ai-time-input"
                        value={schedule[day].time}
                        onChange={(e) => setDayField(day, "time", e.target.value)} />
                      <div className="ai-hours-wrap">
                        <input type="number" className="ai-hours-input" min="1" max="12" placeholder="—"
                          value={schedule[day].hours}
                          onChange={(e) => setDayField(day, "hours", e.target.value)} />
                        <span className="ai-hours-label">ساعة</span>
                      </div>
                    </>
                  )}
                </div>
              );
            })}
          </div>
        </Form.Group>

        {/* Photo */}
        <FormGroup className="mb-2" controlId="photo">
          <Form.Label>صورة الدورة <span className="ai-optional">(اختياري)</span></Form.Label>
          {currentPhoto && !photo && (
            <div style={{ marginBottom: 8 }}>
              <img
                src={`${baseURL}/uploads/intensive/${currentPhoto}`}
                alt="الصورة الحالية"
                style={{ width: 80, height: 80, objectFit: "cover", borderRadius: 10, border: "2px solid #e5e7eb" }}
              />
              <p style={{ margin: "4px 0 0", fontSize: "0.78rem", color: "#6b7280" }}>الصورة الحالية</p>
            </div>
          )}
          <FormControl type="file" accept="image/*"
            onChange={(e) => setPhoto(e.target.files[0] || null)} />
        </FormGroup>
      </DashDialog>
    </>
  );
}
